<template>
  <modal
    v-bind="$attrs"
    v-on="$listeners"
    :title="getTitle"
  >
  <template v-slot:body>
    <p>
      {{
        $t($i18nLabelsHelper(currentOrganizationType, 'modals.delete.message'), {
            numberOfClasses: (type_remove == 'single') ? 1 : numberOfSelectedClasses
        })
      }}
    </p>
  </template>
  <template v-slot:footer>
    <span class="dialog-footer">
      <primary-button
        class="confirm-delete"
        ref=""
        @click.native="handleSubmitDelete"
      >
        {{ $t('organization_profile.remove_admin_modal.yes_remove') }}
      </primary-button>
      <tertiary-button @click.native="$emit('closed')">
        {{ $t('organization_profile.remove_admin_modal.no_cancel') }}
      </tertiary-button>
    </span>
  </template>
  </modal>
</template>

<script>
  import Modal from '@/components/common/Modal'
  import PrimaryButton from '@/components/common/buttons/PrimaryButton'
  import TertiaryButton from '@/components/common/buttons/TertiaryButton'

  export default {
    props: {
      numberOfSelectedClasses: {
        type: Number,
        default: 0,
      },
      type_remove: {
        type: String,
        default: ''
      },
      currentOrganizationType: {}
    },
    components: {
      Modal,
      PrimaryButton,
      TertiaryButton,
    },
    computed: {
      getTitle() {
        return this.$t(this.$i18nLabelsHelper(this.currentOrganizationType, 'modals.delete.title'), {
            numberOfClasses: this.numberOfSelectedClasses
        })
      }
    },
    methods: {
      handleSubmitDelete() {
        this.$emit('closed');
        this.$emit('doDeleteClasses');
      }
    },
  }
</script>

<style lang="scss" scoped>
  @import '../../../scss/_colors.scss';
  p {
  margin: 0;
  font-weight: 500;
  font-size: 20px;
  line-height: 32px;
  text-align: center;
  color: #eb5757;
}
.elsa-button.confirm-delete,
.elsa-button.confirm-delete:hover {
  background: $orange;
  border-radius: 8px;
}
::v-deep .el-dialog__body {
  width: 400px;
  margin: auto;
}
</style>
